(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 768px)';

  function isMobile() {
    if (window.theme && theme.mediaMatches && typeof theme.mediaMatches.md === 'boolean') {
      return !theme.mediaMatches.md;
    }
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function mergeQueryParams(href, search) {
    if (!href || href === '#' || href.indexOf('javascript:') === 0) {
      return href;
    }
    if (!search || search === '?') {
      return href;
    }

    try {
      var isAbsolute = /^https?:\/\//i.test(href);
      var base = isAbsolute ? undefined : window.location.origin;
      var url = new URL(href, base);
      var incoming = new URLSearchParams(search);
      incoming.forEach(function (value, key) {
        if (!url.searchParams.has(key)) {
          url.searchParams.set(key, value);
        }
      });
      if (isAbsolute) {
        return url.toString();
      }
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return href;
    }
  }

  function applyUtmParams(root) {
    var search = window.location.search;
    if (!search) return;
    var links = root.querySelectorAll('[data-campaign-cta]');
    links.forEach(function (link) {
      var href = link.getAttribute('href');
      var next = mergeQueryParams(href, search);
      if (next !== href) {
        link.setAttribute('href', next);
      }
    });
  }

  function initStickyCta(root) {
    var sticky = root.querySelector('[data-campaign-sticky]');
    var heroCta = root.querySelector('#campaign-hero-cta');
    if (!sticky || !heroCta) return;
    if (root.getAttribute('data-sticky-enabled') === 'false') {
      sticky.hidden = true;
      sticky.setAttribute('aria-hidden', 'true');
      return;
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      sticky.classList.add('campaign-lp__sticky--no-motion');
    }

    function setVisible(visible) {
      if (!isMobile()) {
        sticky.hidden = true;
        sticky.setAttribute('aria-hidden', 'true');
        sticky.classList.remove('is-visible');
        root.classList.remove('campaign-lp--sticky-active');
        return;
      }
      if (visible) {
        sticky.hidden = false;
        sticky.setAttribute('aria-hidden', 'false');
        sticky.classList.add('is-visible');
        root.classList.add('campaign-lp--sticky-active');
      } else {
        sticky.classList.remove('is-visible');
        root.classList.remove('campaign-lp--sticky-active');
        sticky.setAttribute('aria-hidden', 'true');
        window.setTimeout(function () {
          if (!sticky.classList.contains('is-visible')) {
            sticky.hidden = true;
          }
        }, reduceMotion ? 0 : 220);
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    observer.observe(heroCta);

    var mq = window.matchMedia(MOBILE_MQ);
    function onBreakpointChange() {
      if (!isMobile()) {
        setVisible(false);
      }
    }
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onBreakpointChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onBreakpointChange);
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-campaign-ready') === 'true') return;
    root.setAttribute('data-campaign-ready', 'true');
    if (root.getAttribute('data-cta-behavior') !== 'open_wizard') {
      applyUtmParams(root);
    }
    initStickyCta(root);
  }

  function boot() {
    document.querySelectorAll('[data-campaign-landing]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-campaign-landing]')
      : null;
    if (!root && event.target && event.target.matches && event.target.matches('[data-campaign-landing]')) {
      root = event.target;
    }
    if (root) {
      root.removeAttribute('data-campaign-ready');
      init(root);
    }
  });
})();
